import {createAsyncThunk, createEntityAdapter, createSlice} from '@reduxjs/toolkit';
import {toast} from "react-toastify";
import {
    addReturnApi,
    addTrackingApi,
    createTrackingInvoiceApi,
    downloadBulkPdfApi,
    downloadInvoiceApi,
    downloadPdfApi,
    downloadTrackingInvoiceApi, exportEvriDataApi, exportNextDayEvriDataApi, generateAllPickingTicketApi,
    generateOrderPdfApi,
    generateOrderShippingDetails,
    generateReturnDetails,
    generateReturnGroupDetails,
    generateVatDetails, getCurrentDeliveryPartnerApi, getLatestPickingTicketApi,
    getOrderCommissionsApi,
    getOrdersApi,
    getOrderSettingsApi,
    getReturnsApi,
    getTrackingItemApi,
    importDpdFileApi,
    sendReturnItemShopifyApi,
    showOrderApi,
    showPendingReturnRequestListApi,
    showPendingReturnReturn,
    showReturnApi,
    showReturnListApi,
    showTrackingInvoiceApi,
    exportVogaClosetImportApi,
    exportVogaClosetApi,
    storePendingReturnRequest, updateDeliveryPartnerApi,
    updateDispatchOrderDataApi, generatePendingReturnDetails,
    importEvriileApi, reassignShippingApi, reassignSellerApi, 
    exportVogaClosetDetailApi,exportVogaClosetNewApi,orderRefundDataApi,
    postReturnsRestockApi,
    updateBinLocationsApi,
    getReturnRestockApi,
} from "../../../services/order";
import {orderFilters, returnOrderFilters, pendingReturnFilters} from "../../manage-product/product/edit/content/settings/map";


export const getOrders = createAsyncThunk('orders/getAllOrders', async (data, {dispatch,}) => {
    const response = await getOrdersApi(data);
    dispatch(setTableRowCount(response.response.count));
    return response.response.data;
});


export const showOrder = createAsyncThunk('orders/getOrder', async (data, {dispatch}) => {
    const response = await showOrderApi(data.id,data.params);
    return response.response;
});

export const downloadOrderPdf = createAsyncThunk('orders/downloadPdfSlip', async (data, {dispatch}) => {
    const response = await downloadPdfApi(data.id, data.params);
    return response.response;
});

export const downloadBulkOrderPdf = createAsyncThunk('orders/downloadBulkPdfSlip', async (data, {dispatch}) => {
    const response = await downloadBulkPdfApi(data);
    return response.response;
});


export const downloadOrderInvoice = createAsyncThunk('orders/downloadInvoice', async (data, {dispatch}) => {
    const response = await downloadInvoiceApi(data.id,data.params);
    return response.response;
});

export const getOrderSettings = createAsyncThunk('order/getOrderSettings', async () => {
    const response = await getOrderSettingsApi();
    return response.response;
});

export const exportOrderShippingDetails = createAsyncThunk('order/exportShoppingData', async (data, {dispatch}) => {
    const response = await generateOrderShippingDetails(data);
    return response.response;
});

export const exportVatDetails = createAsyncThunk('order/exportVatData', async (data, {dispatch}) => {
    const response = await generateVatDetails(data);
    return response.response;
});

export const generateOrderPdfData = createAsyncThunk('order/generateOrderPdf', async (data, {dispatch}) => {
    const response = await generateOrderPdfApi(data);
    return response.response;
});

export const exportEvriData = createAsyncThunk('order/generateOrderPdf', async (data, {dispatch}) => {
    const response = await exportEvriDataApi(data);
    return response.response;
});

export const exportNextDayEvriData = createAsyncThunk('order/generateOrderPdf', async (data, {dispatch}) => {
    const response = await exportNextDayEvriDataApi(data);
    return response.response;
});

export const vogaClosetExport = createAsyncThunk('order/vogaClostExport', async (data, {dispatch}) => {
    const response = await exportVogaClosetApi(data);
    return response.response;
});

export const vogaClosetNewExport = createAsyncThunk('order/vogaClostNewExport', async (data, {dispatch}) => {
    const response = await exportVogaClosetNewApi(data);
    return response.response;
});

export const vogaClosetDetailExport = createAsyncThunk('order/vogaClostNewExport', async (data, {dispatch}) => {
    const response = await exportVogaClosetDetailApi(data);
    return response.response;
});


export const exportVogaClosetImport = createAsyncThunk('order/importVogaCloset', async (data, {dispatch}) => {
    const response = await exportVogaClosetImportApi(data);
    return response.response;
});

export const addReturnItems = createAsyncThunk('order/addReturnItems', async (returnItems, {dispatch, getState}) => {
    try {
        const response = await addReturnApi(returnItems);
        const data = await response.response;
        toast.success("Returns added successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const sendReturnItemShopify = createAsyncThunk('orders/sendReturnItemShopify', async (data, {dispatch}) => {

    try {
        const response = await sendReturnItemShopifyApi(data);
        toast.success(`Return sent to shopify successfully`, {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        toast.error("Failed to process request", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }


});


export const createTrackingInvoice = createAsyncThunk('order/createInvoiceTracking', async (trackingItems, {
    dispatch,
    getState
}) => {
    try {
        const response = await createTrackingInvoiceApi(trackingItems);
        const data = await response.response;
        toast.success("Invoice created successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {

        return Promise.reject(e);
    }
});

export const addTrackingItems = createAsyncThunk('order/addTracking', async (trackingItems, {dispatch, getState}) => {
    try {
        const response = await addTrackingApi(trackingItems);
        toast.success("Tracking added successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });

        return await response.response;
    } catch (e) {
        toast.error("Failed to process request", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }
});

export const downloadTrackingInvoice = createAsyncThunk('orders/downloadTrackingInvoice', async (id, {dispatch}) => {
    const response = await downloadTrackingInvoiceApi(id);
    return response.response;
});


export const showTrackingInvoice = createAsyncThunk('orders/getTrackingInvoice', async (id, {dispatch}) => {
    const response = await showTrackingInvoiceApi(id);
    return response.response;
});

export const getTrackingItem = createAsyncThunk('orders/getOrderPacking', async (id, {dispatch,}) => {
    const response = await getTrackingItemApi(id);
    return response.response;
});

export const returnRestock = createAsyncThunk('orders/returnRestock', async (data, {dispatch}) => {
    const response = await postReturnsRestockApi(data);
    toast.success(response.response, {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const getReturns = createAsyncThunk('orders/getAllReturns', async (data, {dispatch,}) => {
    const response = await getReturnsApi(data);
    dispatch(setTableRowCount(response.response.count));
    return response.response.data;
});

export const getReturnRestockList = createAsyncThunk('orders/getAllReturnRestock', async (data, {dispatch,}) => {
    const response = await getReturnRestockApi(data);
    dispatch(setTableRowCount(response.response.count));
    return response.response.data;
});

export const showReturnList = createAsyncThunk('orders/getReturnList', async (id, {dispatch}) => {
    const response = await showReturnListApi(id);
    return response.response;
});

export const showReturn = createAsyncThunk('orders/getReturn', async (data, {dispatch}) => {
    const response = await showReturnApi(data.id, data.params);
    return response.response;
});

export const exportReturnDetails = createAsyncThunk('order/exportReturnData', async (data, {dispatch}) => {
    const response = await generateReturnDetails(data);
    return response.response;
});

export const exportReturnGroupDetails = createAsyncThunk('order/exportReturnData', async (data, {dispatch}) => {
    const response = await generateReturnGroupDetails(data);
    return response.response;
});

export const getAllPendingReturnRequest = createAsyncThunk('orders/getAllPendingReturnRequest', async (data, {dispatch,}) => {

    const response = await showPendingReturnRequestListApi(data);
    dispatch(setTableRowCount(response.response.count));
    dispatch(setCustomerReturnReasons(response.response.return_reasons));
    return response.response.data;
});

export const showPendingReturnRequestList = createAsyncThunk('orders/getPendingReturnReturn', async (data, {dispatch}) => {
    const response = await showPendingReturnReturn(data.id, data.params);
    return response.response;
});

export const updateDispatchOrderData = createAsyncThunk('order/updateDispatchOrderData', async (data, {dispatch}) => {
    const response = await updateDispatchOrderDataApi(data);
    toast.success("Order dispatched successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const importDpdData = createAsyncThunk('order/getSelectedOrderData', async (data, {dispatch}) => {
    const response = await importDpdFileApi(data);
    toast.success("File imported successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});
export const importEvriData = createAsyncThunk('order/everiImport', async (data, {dispatch}) => {
    const response = await importEvriileApi(data);
    toast.success("File imported successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const updateDeliveryPartner = createAsyncThunk('order/updateDeliveryPartner', async (data, {dispatch}) => {
    const response = await updateDeliveryPartnerApi(data);
    toast.success("Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});
export const getCurrentDeliveryPartner = createAsyncThunk('order/getCurrentDeliveryPartner', async (data, {dispatch}) => {
    const response = await getCurrentDeliveryPartnerApi(data);
    return response.response;
});

export const storeReturnRequest = createAsyncThunk('orders/storePendingReturnRequest', async (data, {dispatch}) => {

    try {
        const response = await storePendingReturnRequest(data);
        toast.success(`Return Request updated successfully`, {
            position: toast.POSITION.TOP_RIGHT,
        });
        return response.response;
    } catch (e) {
        toast.error("Failed to process request", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return Promise.reject(e);
    }

});

export const getOrderCommissions = createAsyncThunk('orders/getOrderCommissions', async (data, {dispatch,}) => {
    const response = await getOrderCommissionsApi(data);
    dispatch(setTableRowCount(response.response.count));
    return response.response.data;
});

export const generateAllPickingTicket = createAsyncThunk('orders/generateAllPickingTicket', async (data, {dispatch,}) => {
    const response = await generateAllPickingTicketApi(data);
    return response.response;
});

export const exportPendingReturnDetails = createAsyncThunk('order/exportPendingReturnDetails', async (data, {dispatch}) => {
    const response = await generatePendingReturnDetails(data);
    return response.response;
});

export const getLatestPickingTicket = createAsyncThunk('orders/getLatestTicket', async (id, {dispatch}) => {
    const response = await getLatestPickingTicketApi();
    return response.response;
});

export const reassignShipping = createAsyncThunk('orders/reassignShipping', async (data, {dispatch}) => {
    const response = await reassignShippingApi(data);
    toast.success("Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const orderRefundData = createAsyncThunk('orders/orderRefundData', async (data, {dispatch}) => {
    const response = await orderRefundDataApi(data.id);
    return response.response;
});

export const reassignSeller = createAsyncThunk('orders/reassignSeller', async (data, {dispatch}) => {
    const response = await reassignSellerApi(data);
    toast.success("Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

export const updateBinLocations = createAsyncThunk('order/updateBinLocations', async (data, {dispatch}) => {
    const response = await updateBinLocationsApi(data);
    toast.success(response.response.message, {
        position: toast.POSITION.TOP_RIGHT,
    });
    return response.response;
});

const ordersAdapter = createEntityAdapter({});
const checkoutAdapter = createEntityAdapter({});

export const {selectAll: selectOrder, selectById: selectOrderById} = ordersAdapter.getSelectors(
    state => state.order.order
);

export const {selectAll: selectCheckouts, selectById: selectCheckoutById} = checkoutAdapter.getSelectors(
    state => state.order.checkout
);


const orderSlice = createSlice({
    name: 'orders',
    initialState: ordersAdapter.getInitialState({
        id: null,
        orderTableRow: 0,
        checkoutTableRow: 0,
        searchText: '',
        customerReturnReasons: [],
        settings: {
            returnReasons: [],
            countries: [],
            deliveryPartners: [],
            shippingType: [],
            brands: [],
            exchangeTypes: [],
            refundStatus: [],
            returnReasonsCustomer:[],
            partner: []
        },
        data: null,
        invoice_data: [],
        tracking: null,
        selectedInvoiceID: null,
        commissionData: null,
        latestPickingTickets:[],
        newInvoiceDialog: {
            component: 'Invoice',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
        addTrackingDialog: {
            component: 'Tracking',
            type: 'new',
            props: {
                open: false
            },
            data: null
        },
        refundModal: {
            props: {
                open: false
            },
            data: null
        },
        actionDialog: {
            component: 'Action',
            type: 'new',
            props: {
                open: false
            },
            data: null,
            modalType: 0
        },
        pickingTicketDialogs:{
            props: {
                isOpen: false
            },
        },
        returnData: null,
        returnRequestData: null,
        list: [],
        trackingDetails: null,
        filter: orderFilters(),
        filters: returnOrderFilters(),
        pendingFilters: pendingReturnFilters(),
        currentDeliveryPartner: [],
        currentDeliveryPartners: [],
        deliverPartner:[],
        refundDetail: {
            id:'',
            OrderFundQuantity:'',
            customerReturnQuantity:'',
            sellerReturnQuantity:'',
            order_id: '',
            return_total: '',
            seller: '',
            status: '',
            sku:'',
            return_date: '',
            status_date: '',  
            type: '',
            is_restock:'', 
            is_declined: '',
            order_name: '',
            order_refund_next: '',
            order_refund_prev:'' 
        },
        binInfoModal:{
            component: 'Bin Number',
            type: 'edit',
            props: {
                open: false
            },
            data: null
        },
    }),
    reducers: {
        setSettings: (state, action) => {
            // state.setting= action.payload.settings;
            state.settings.returnReasons = action.payload.returnReasons.admin;
            state.settings.returnReasonsCustomer = action.payload.returnReasons.customer;
            state.settings.countries = action.payload.countries;
            state.settings.deliveryPartners = action.payload.deliveryPartners;
            state.settings.shippingType = action.payload.shippingType;
            state.settings.brands = action.payload.brands;
            state.settings.exchangeTypes = action.payload.exchangeTypes;
            state.settings.refundStatus = action.payload.refundStatus;
            state.settings.partner = action.payload.partner;
        },
        setOrderData: (state, action) => {
            state.data = action.payload.data;
            state.list = action.payload.list;
            state.trackingDetails = action.payload.tracking ? action.payload.tracking : null;
            state.tracking = null;
            state.address = action.payload.address;
            state.deliverPartner = action.payload.deliverPartner;
        },
        setReturnOrderData: (state, action) => {
            state.data = action.payload.data;
            state.invoice_data = action.payload.invoice_data;
            state.list = action.payload.list;;
        },
        setTrackingData: (state, action) => {
            state.tracking = action.payload;
        },
        unSetTrackingData: (state, action) => {
            state.tracking = null;
        },
        setReturnData: (state, action) => {
            state.returnData = action.payload;
        },
        setCommissionData: (state, action) => {
            state.commissionData = action.payload;
        },
        setTableRowCount: (state, action) => {
            state.orderTableRow = action.payload;
        },
        setCustomerReturnReasons: (state, action) => {
            state.customerReturnReasons = action.payload
        },

        setOrderListPackQty: (state, action) => {
            // state.list[action.payload.index].pack=action.payload.pack;
        },
        setRefundModal: (state, action) => {
            state.refundModal=action.payload;
        },
        openNewInvoiceDialog: (state, action) => {
            state.newInvoiceDialog = {
                component: 'Invoice',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null
            };
        },
        closeNewInvoiceDialog: (state, action) => {
            state.newInvoiceDialog = {
                component: 'Invoice',
                type: 'new',
                props: {
                    isOpen: false,
                },
                data: null
            };
        },
        openNewTrackingDialog: (state, action) => {
            state.addTrackingDialog = {
                component: 'Tracking',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null
            };
            state.selectedInvoiceID = action.payload;
        },
        closeNewTrackingDialog: (state, action) => {
            state.addTrackingDialog = {
                component: 'Tracking',
                type: 'new',
                props: {
                    isOpen: false,
                },
                data: null
            };
            state.selectedInvoiceID = null;
        },
        setReturnRequestData: (state, action) => {
            state.returnRequestData = action.payload;
        },
        setOrderFilter: (state, action) => {
            state.filter = action.payload
        },
        setReturnOrderFilter: (state, action) => {
            state.filters = action.payload
        },
        setPendingReturnFilter: (state, action) => {
            state.pendingFilters = action.payload
        },
        openActionDialog: (state, action) => {
            state.actionDialog = {
                component: 'Action',
                type: 'new',
                props: {
                    isOpen: true
                },
                data: null,
                modalType: action.payload.dat.type
            };
        },
        closeActionDialog: (state, action) => {
            state.actionDialog = {
                component: 'Action',
                type: 'new',
                props: {
                    isOpen: false
                },
                data: null,
            };
        },
        setCurrentDeliveryPartner: (state, action) => {
            state.currentDeliveryPartner = action.payload
        },
        setCurrentDeliveryPartners: (state, action) => {
            state.currentDeliveryPartners = action.payload
        },
        openPickingTicketDialogs: (state, action) => {
            state.pickingTicketDialogs = {
                props: {
                    isOpen: action.payload
                },
            };
        },
        setLatestPickingTickets: (state, action) => {
            state.latestPickingTickets = action.payload
        },
        setRefundData: (state, action) => {
            state.refundDetail = action.payload;
        },   
        openBinInfoModal: (state, action) => {
            state.binInfoModal = {
                component: 'Bin Number',
                type: 'edit',
                props: {
                    isOpen: true
                },
                data: action.payload.data ? action.payload.data : null
            };
        },
        closeBinInfoModal: (state, action) => {
            state.binInfoModal = {
                type: 'edit',
                props: {
                    isOpen: false
                },
                data: null
            };
        },
        setList: (state, action) => {
            state.list = action.payload;
        }
    },
    extraReducers: {
        [getOrders.fulfilled]: ordersAdapter.setAll,
        // [updateStaff.fulfilled]: staffsAdapter.setAll
        // [deleteStaff.fulfilled]: staffsAdapter.removeOne,
    }
});

export const {
    setSettings,
    setTableRowCount,
    setOrderData,
    setReturnData,
    setTrackingData,
    unSetTrackingData,
    openNewInvoiceDialog,
    setCheckoutTableRowCount,
    closeNewInvoiceDialog,
    openNewTrackingDialog,
    closeNewTrackingDialog,
    setOrderListPackQty,
    setReturnRequestData,
    setCommissionData,
    setOrderFilter,
    openActionDialog,
    closeActionDialog,
    setCurrentDeliveryPartner,
    setCurrentDeliveryPartners,
    setCustomerReturnReasons,
    setRefundModal,
    setReturnOrderData,
    openPickingTicketDialogs,
    setLatestPickingTickets, setRefundData, setReturnOrderFilter, setPendingReturnFilter,
    openBinInfoModal, closeBinInfoModal,
    setList
} =
    orderSlice.actions;

export default orderSlice.reducer;
